// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --blue: #0057a8;
  --blue-dark: #003f7a;
  --blue-light: #e8f0f9;
  --grey-100: #f5f5f5;
  --grey-200: #e0e0e0;
  --grey-500: #9e9e9e;
  --grey-800: #424242;
  --text: #212121;
  --border: #bdbdbd;
  --radius: 4px;
  --shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  --font: 'Segoe UI', Arial, sans-serif;
}

html, body {
  height: 100%;
  font-family: var(--font);
}

/* Hide Alpine-managed elements until the runtime has evaluated their
   directives. Without this, the Sign in and Sign out buttons (which
   toggle via x-show on \`loggedIn\`) would both render briefly before
   Alpine boots. */
[x-cloak] { display: none !important; }

#header {
  height: 60px;
  background-color: var(--blue);
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 20px;
  box-shadow: var(--shadow);
  z-index: 1001;
  position: relative;
}

#header .logo {
  height: 44px;
  margin-right: 12px;
}

#header .title {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
  flex: 1;
}

#header .header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

#header .header-link {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #fff;
  text-decoration: none;
  font-family: var(--font);
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.35rem 0.85rem;
  border: none;
  border-radius: var(--radius);
  background: transparent;
  transition: background 0.15s;
}

#header .header-link:hover {
  background: transparent;
  color: #fff;
  text-decoration: underline;
}

#header .header-link:active {
  background: rgba(0, 0, 0, 0.15);
  text-decoration: underline;
}

#header .header-link[aria-current="page"] {
  color: #fff;
  background: rgba(0, 0, 0, 0.15);
}

#header .menu-toggle {
  display: none;
  background: transparent;
  border: 0;
  color: #fff;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: var(--radius);
  cursor: pointer;
}
#header .menu-toggle svg { width: 24px; height: 24px; display: block; }
#header .menu-toggle:hover { background: rgba(0, 0, 0, 0.15); }
#header .menu-toggle:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }

@media (max-width: 600px) {
  #header { padding: 0 12px; gap: 0.5rem; }
  #header .logo { height: 32px; margin-right: 6px; }
  #header .title { font-size: 1rem; letter-spacing: 0.5px; }
  #header .menu-toggle { display: inline-flex; }
  #header .header-actions {
    display: none;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 0;
    background: var(--blue);
    padding: 6px 0;
    box-shadow: var(--shadow);
    z-index: 1000;
  }
  #header.nav-open .header-actions { display: flex; }
  #header .header-actions > a,
  #header .header-actions > button {
    width: 100%;
    padding: 12px 20px;
    min-height: 44px;
    border-radius: 0;
    justify-content: flex-start;
    background: transparent;
    color: #fff;
  }
  #header .header-actions > a:hover,
  #header .header-actions > button:hover {
    background: rgba(0, 0, 0, 0.15);
    text-decoration: none;
  }
}

#measure-control {
  position: absolute;
  top: 150px;
  right: 8px;
  z-index: 1;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

#measure-control:hover {
  background: #fff;
}

#measure-control.active {
  background: #0057a8;
}

#measure-control svg {
  width: 24px;
  height: 24px;
  fill: #333;
}

#measure-control.active svg {
  fill: #fff;
}

#measure-control .dropdown {
  display: none;
  position: absolute;
  top: 44px;
  right: 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

#measure-control.active .dropdown {
  display: block;
}

#measure-control .dropdown button {
  display: block;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

#measure-control .dropdown button:hover {
  background: #f0f0f0;
}

#measure-tooltip,
.measure-tooltip {
  position: absolute;
  right:5px;
  top: 250px;
  z-index: 1;
  background: rgba(0, 63, 122, 0.9);
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 13px;
  pointer-events: none;
  display: none;
}

#map {
  width: 100%;
  /* Viewport minus header (60px) and compact footer (33px, see
     secims_view/css/footer.css). */
  height: calc(100vh - 60px - 33px);
  position: relative;
}

.ol-zoom {
  left: auto;
  right: 8px;
}

#zoom-level {
  position: absolute;
  top: 70px;
  right: 8px;
  z-index: 1;
  background: rgba(255, 255, 255, 0.8);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  color: #333;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.ol-scale-line {
  left: auto;
  right: 8px;
  bottom: 30px;
}

/* Cartographic key. Anchored 24px above the scale bar (which sits at
   bottom: 30px), so the two stack cleanly. Width auto-fits content
   but capped so very long rule labels wrap rather than push the panel
   off-screen. */
#map-key {
  position: absolute;
  left: 8px;
  bottom: 54px;
  z-index: 1;
  max-width: 240px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #c8d2dc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  padding: 6px 9px;
  font-size: 11px;
  color: #333;
  line-height: 1.35;
}

.map-key-section + .map-key-section {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #e2e8f0;
}

.map-key-title {
  font-weight: 600;
  color: #003f7a;
  margin-bottom: 3px;
  /* Wrap rather than ellipsize — the panel has a fixed max-width
     (#map-key max-width: 240px) so even verbose titles stay bounded,
     and attribute names (e.g. POPULATION_2000) shouldn't be hidden. */
  word-break: break-word;
}

/* Classification attribute inside the title — slightly de-emphasised
   (regular weight + lower opacity) so the eye lands on the layer name. */
.map-key-attr {
  font-weight: 400;
  font-style: italic;
  color: #4a6a85;
}

.map-key-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 1px 0;
}

.map-key-swatch {
  display: inline-block;
  flex-shrink: 0;
  border-style: solid;
}

.map-key-swatch-polygon {
  width: 16px;
  height: 12px;
  border-width: 1px;
}

.map-key-swatch-point {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border-width: 1px;
}

.map-key-swatch-line {
  width: 20px;
  /* height set inline from the rule's stroke width */
  border: none;
}

.map-key-label {
  flex: 1;
  word-break: break-word;
}

#compass {
  position: absolute;
  bottom: 108px;
  right: 8px;
  z-index: 1;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(0, 63, 122, 0.88);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

#compass:hover {
  background: rgba(0, 87, 168, 0.95);
}

#compass-needle {
  width: 100%;
  height: 100%;
  transition: transform 0.1s ease-out;
}

/* ── Legend Panel ──────────────────────────────────────────────────── */

#legend-panel {
  position: absolute;
  left: 8px;
  top: 8px;
  z-index: 1000;
  min-width: 220px;
  max-width: 280px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 4px;
  box-shadow: var(--shadow);
  color: var(--text);
  font-size: 12px;
  overflow: hidden;
}

/* Toggle button */

#legend-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  cursor: pointer;
  background: var(--blue);
  border: none;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

#legend-toggle:hover {
  background: var(--blue-dark);
}

#legend-toggle svg {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  transition: transform 0.25s ease;
  transform: rotate(90deg);
}

#legend-panel.collapsed #legend-toggle svg {
  transform: rotate(0deg);
}

/* Collapsible body */

#legend-body {
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  overflow-x: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  opacity: 1;
}

#legend-panel.collapsed #legend-body {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

/* Sections */

.legend-section {
  padding: 0 0 4px 0;
}

.legend-section-title {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #666;
  padding: 6px 10px 2px;
  user-select: none;
}

.legend-empty {
  font-size: 11px;
  font-style: italic;
  color: #666;
  padding: 4px 10px 8px;
}

.legend-divider {
  border-top: 1px solid var(--grey-200);
  margin: 4px 0;
}

/* Layer item row */

.legend-item {
  transition: opacity 0.2s;
}

.legend-item.dragging {
  opacity: 0.4;
}

.legend-item.drag-over {
  border-top: 2px solid #0057a8;
}

.legend-item-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  cursor: default;
}

.legend-item-row:hover {
  background: var(--blue-light);
}

/* Drag handle */

.drag-handle {
  cursor: grab;
  color: #666;
  font-size: 12px;
  user-select: none;
  line-height: 1;
}

.drag-handle:active {
  cursor: grabbing;
}

/* Checkbox */

.legend-checkbox {
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #0057a8;
}

/* Thumbnail slot */

.legend-thumbnail {
  width: 24px;
  height: 24px;
  border-radius: 2px;
  background: #fff;
  border: 1px solid var(--border);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Layer label */

.legend-label {
  flex: 1;
  font-size: 12px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  user-select: none;
}

/* Accordion chevron */

.legend-chevron {
  cursor: pointer;
  font-size: 10px;
  color: #666;
  transition: transform 0.2s ease;
  user-select: none;
  padding: 0 2px;
}

.legend-item.open .legend-chevron {
  transform: rotate(180deg);
}

/* Accordion panel */

.legend-accordion {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.25s ease, padding 0.25s ease;
  background: var(--grey-100);
  padding: 0 10px;
}

.legend-item.open .legend-accordion {
  max-height: 120px;
  padding: 6px 10px;
}

/* Opacity slider row */

.transparency-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  margin-bottom: 6px;
}

.transparency-row label {
  color: #555;
  white-space: nowrap;
}

.legend-opacity-slider {
  flex: 1;
  height: 4px;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: var(--grey-200);
  border-radius: 2px;
  outline: none;
}

/* Track */
.legend-opacity-slider::-webkit-slider-runnable-track {
  height: 4px;
  background: var(--grey-200);
  border-radius: 2px;
}

.legend-opacity-slider::-moz-range-track {
  height: 4px;
  background: var(--grey-200);
  border-radius: 2px;
  border: none;
}

/* Thumb — draggable circle */
.legend-opacity-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #0057a8;
  border: 2px solid #fff;
  cursor: grab;
  margin-top: -5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.legend-opacity-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #0057a8;
  border: 2px solid #fff;
  cursor: grab;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.legend-opacity-slider::-webkit-slider-thumb:active {
  cursor: grabbing;
  background: #003f7a;
  transform: scale(1.15);
}

.legend-opacity-slider::-moz-range-thumb:active {
  cursor: grabbing;
  background: #003f7a;
  transform: scale(1.15);
}

.legend-opacity-value {
  min-width: 32px;
  text-align: right;
  color: #555;
  font-size: 11px;
}

/* Download and metadata links */

.legend-download-link,
.legend-metadata-link,
.legend-zoom-link {
  display: block;
  font-size: 11px;
  color: #0057a8;
  text-decoration: none;
  margin-bottom: 4px;
}

.legend-download-link:hover,
.legend-metadata-link:hover,
.legend-zoom-link:hover {
  text-decoration: underline;
  color: #003f7a;
}

.legend-download-note {
  font-size: 10px;
  color: #777;
  font-style: italic;
}

/* Row wrapper that pairs a download link with "Zoom to Extent" —
   download on the left, zoom right-justified. The margin-left: auto
   on the zoom link also handles the standalone case (no download
   link present) by pushing it to the row's right edge. */
.legend-link-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.legend-link-row > .legend-download-link,
.legend-link-row > .legend-metadata-link,
.legend-link-row > .legend-zoom-link {
  margin-bottom: 0;
}

.legend-link-row > .legend-zoom-link {
  margin-left: auto;
}

/* Scrollbar styling for legend body */

#legend-body::-webkit-scrollbar {
  width: 6px;
}

#legend-body::-webkit-scrollbar-track {
  background: transparent;
}

#legend-body::-webkit-scrollbar-thumb {
  background: rgba(0, 87, 168, 0.25);
  border-radius: 3px;
}

#legend-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 87, 168, 0.4);
}

/* ── Feature popup ──────────────────────────────────────────────── */

.ol-popup {
  background: #fff;
  border-radius: 6px;
  padding: 12px 14px 12px 14px;
  min-width: 200px;
  max-width: 380px;
  max-height: 430px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  font-family: var(--font);
  font-size: 13px;
}

.ol-popup:after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #fff;
}

.ol-popup-closer {
  position: absolute;
  top: 6px;
  right: 8px;
  text-decoration: none;
  font-size: 18px;
  color: #999;
  line-height: 1;
  z-index: 1;
}

.ol-popup-closer:hover {
  color: #333;
}

.ol-popup-closer:after {
  content: '\\00d7';
}

.popup-title {
  font-weight: 600;
  font-size: 13px;
  color: #003f7a;
  margin-bottom: 6px;
  padding-bottom: 4px;
  padding-right: 20px;
  border-bottom: 2px solid #0057a8;
}

.popup-table {
  border-collapse: collapse;
  width: 100%;
}

.popup-table td {
  padding: 3px 6px 3px 0;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: top;
}

.popup-key {
  font-weight: 600;
  color: #555;
  font-size: 12px;
  max-width: 140px;
  word-break: break-word;
}

.popup-val {
  color: #333;
  word-break: break-word;
}

.popup-val img {
  display: block;
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

#popup-content {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 350px;
}

#popup-content .popup-table-wrap {
  overflow-y: auto;
  flex: 1;
}

/* Popup tabs */

.popup-tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 6px;
  flex-shrink: 0;
}

.popup-tab {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.popup-tab:hover {
  color: #003f7a;
}

.popup-tab.active {
  color: #003f7a;
  border-bottom-color: #0057a8;
}

.popup-tab-panel {
  display: none;
  flex: 1;
  overflow: hidden;
}

.popup-tab-panel.active {
  display: flex;
  flex-direction: column;
}

/* ── Metadata modal ─────────────────────────────────────────────── */

#metadata-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.metadata-modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.metadata-modal-content {
  position: relative;
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 640px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.metadata-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #003f7a;
  color: #fff;
  border-radius: 8px 8px 0 0;
  flex-shrink: 0;
}

.metadata-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.metadata-modal-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.metadata-modal-pdf {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 4px;
  white-space: nowrap;
}

.metadata-modal-pdf:hover {
  background: rgba(255, 255, 255, 0.25);
}

.metadata-modal-download {
  background: #fff;
  border: 1px solid #fff;
  color: var(--blue-dark);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 4px;
  white-space: nowrap;
}

.metadata-modal-download:hover:not(:disabled) {
  background: #e8f0f9;
}

.metadata-modal-download:disabled {
  opacity: 0.6;
  cursor: default;
}

.metadata-modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
  opacity: 0.7;
}

.metadata-modal-close:hover {
  opacity: 1;
}

.metadata-modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.metadata-modal-loading {
  text-align: center;
  color: #666;
  padding: 40px 0;
}

.metadata-modal-error {
  color: #c62828;
  padding: 20px;
  text-align: center;
}

/* Metadata sections */

.metadata-sections {
  font-family: var(--font);
  font-size: 14px;
  color: #333;
}

.metadata-section {
  margin-bottom: 16px;
}

.metadata-section h4 {
  margin: 0 0 8px 0;
  padding: 6px 0;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #003f7a;
  border-bottom: 2px solid #0057a8;
}

.metadata-section-body {
  padding-left: 2px;
}

.metadata-row {
  display: flex;
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
}

.metadata-label {
  flex: 0 0 140px;
  font-weight: 600;
  color: #555;
  font-size: 13px;
}

.metadata-value {
  flex: 1;
  word-break: break-word;
}

.metadata-badge {
  display: inline-block;
  background: #e8f0f9;
  color: #003f7a;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
  margin: 2px 2px;
}

.metadata-contact {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  line-height: 1.6;
}

.metadata-contact:last-child {
  border-bottom: none;
}

.metadata-contact-type {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #003f7a;
  margin-bottom: 3px;
}

.metadata-bbox-map {
  width: 100%;
  height: 220px;
  margin-top: 8px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.metadata-contact a {
  color: #0057a8;
  text-decoration: none;
}

.metadata-contact a:hover {
  text-decoration: underline;
}

.metadata-links a {
  display: inline-block;
  background: #0057a8;
  color: #fff;
  padding: 4px 10px;
  border-radius: 3px;
  font-size: 12px;
  text-decoration: none;
  margin: 2px;
}

.metadata-links a:hover {
  background: #003f7a;
}
`, "",{"version":3,"sources":["webpack://./css/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;;kBAGkB;AAClB,YAAY,wBAAwB,EAAE;;AAEtC;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,4BAA4B;EAC5B,eAAe;AACjB;AACA,2BAA2B,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACtE,6BAA6B,+BAA+B,EAAE;AAC9D,qCAAqC,uBAAuB,EAAE,mBAAmB,EAAE;;AAEnF;EACE,UAAU,eAAe,EAAE,WAAW,EAAE;EACxC,gBAAgB,YAAY,EAAE,iBAAiB,EAAE;EACjD,iBAAiB,eAAe,EAAE,qBAAqB,EAAE;EACzD,uBAAuB,oBAAoB,EAAE;EAC7C;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,iBAAiB;IACjB,MAAM;IACN,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,aAAa;EACf;EACA,mCAAmC,aAAa,EAAE;EAClD;;IAEE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;EACb;EACA;;IAEE,+BAA+B;IAC/B,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,iCAAiC;EACjC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX;mCACiC;EACjC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;;;gBAGgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB;;sEAEoE;EACpE,sBAAsB;AACxB;;AAEA;yEACyE;AACzE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA,yEAAyE;;AAEzE;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;;AAElB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;;AAErB;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA,aAAa;;AAEb;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA,mBAAmB;;AAEnB;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gBAAgB;;AAEhB;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,aAAa;;AAEb;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gBAAgB;;AAEhB;EACE,OAAO;EACP,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,sBAAsB;;AAEtB;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,gBAAgB;EAChB,qDAAqD;EACrD,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA,gCAAgC;;AAEhC;;;EAGE,cAAc;EACd,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;yDAGyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sCAAsC;;AAEtC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,sEAAsE;;AAEtE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,OAAO;AACT;;AAEA,eAAe;;AAEf;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,sEAAsE;;AAEtE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB;EACE,wBAAwB;EACxB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --blue: #0057a8;\n  --blue-dark: #003f7a;\n  --blue-light: #e8f0f9;\n  --grey-100: #f5f5f5;\n  --grey-200: #e0e0e0;\n  --grey-500: #9e9e9e;\n  --grey-800: #424242;\n  --text: #212121;\n  --border: #bdbdbd;\n  --radius: 4px;\n  --shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n  --font: 'Segoe UI', Arial, sans-serif;\n}\n\nhtml, body {\n  height: 100%;\n  font-family: var(--font);\n}\n\n/* Hide Alpine-managed elements until the runtime has evaluated their\n   directives. Without this, the Sign in and Sign out buttons (which\n   toggle via x-show on `loggedIn`) would both render briefly before\n   Alpine boots. */\n[x-cloak] { display: none !important; }\n\n#header {\n  height: 60px;\n  background-color: var(--blue);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0 20px;\n  box-shadow: var(--shadow);\n  z-index: 1001;\n  position: relative;\n}\n\n#header .logo {\n  height: 44px;\n  margin-right: 12px;\n}\n\n#header .title {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  flex: 1;\n}\n\n#header .header-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n#header .header-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: #fff;\n  text-decoration: none;\n  font-family: var(--font);\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.35rem 0.85rem;\n  border: none;\n  border-radius: var(--radius);\n  background: transparent;\n  transition: background 0.15s;\n}\n\n#header .header-link:hover {\n  background: transparent;\n  color: #fff;\n  text-decoration: underline;\n}\n\n#header .header-link:active {\n  background: rgba(0, 0, 0, 0.15);\n  text-decoration: underline;\n}\n\n#header .header-link[aria-current=\"page\"] {\n  color: #fff;\n  background: rgba(0, 0, 0, 0.15);\n}\n\n#header .menu-toggle {\n  display: none;\n  background: transparent;\n  border: 0;\n  color: #fff;\n  width: 44px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n#header .menu-toggle svg { width: 24px; height: 24px; display: block; }\n#header .menu-toggle:hover { background: rgba(0, 0, 0, 0.15); }\n#header .menu-toggle:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }\n\n@media (max-width: 600px) {\n  #header { padding: 0 12px; gap: 0.5rem; }\n  #header .logo { height: 32px; margin-right: 6px; }\n  #header .title { font-size: 1rem; letter-spacing: 0.5px; }\n  #header .menu-toggle { display: inline-flex; }\n  #header .header-actions {\n    display: none;\n    position: absolute;\n    top: 60px;\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    gap: 0;\n    background: var(--blue);\n    padding: 6px 0;\n    box-shadow: var(--shadow);\n    z-index: 1000;\n  }\n  #header.nav-open .header-actions { display: flex; }\n  #header .header-actions > a,\n  #header .header-actions > button {\n    width: 100%;\n    padding: 12px 20px;\n    min-height: 44px;\n    border-radius: 0;\n    justify-content: flex-start;\n    background: transparent;\n    color: #fff;\n  }\n  #header .header-actions > a:hover,\n  #header .header-actions > button:hover {\n    background: rgba(0, 0, 0, 0.15);\n    text-decoration: none;\n  }\n}\n\n#measure-control {\n  position: absolute;\n  top: 150px;\n  right: 8px;\n  z-index: 1;\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#measure-control:hover {\n  background: #fff;\n}\n\n#measure-control.active {\n  background: #0057a8;\n}\n\n#measure-control svg {\n  width: 24px;\n  height: 24px;\n  fill: #333;\n}\n\n#measure-control.active svg {\n  fill: #fff;\n}\n\n#measure-control .dropdown {\n  display: none;\n  position: absolute;\n  top: 44px;\n  right: 0;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n#measure-control.active .dropdown {\n  display: block;\n}\n\n#measure-control .dropdown button {\n  display: block;\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n}\n\n#measure-control .dropdown button:hover {\n  background: #f0f0f0;\n}\n\n#measure-tooltip,\n.measure-tooltip {\n  position: absolute;\n  right:5px;\n  top: 250px;\n  z-index: 1;\n  background: rgba(0, 63, 122, 0.9);\n  color: #fff;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  pointer-events: none;\n  display: none;\n}\n\n#map {\n  width: 100%;\n  /* Viewport minus header (60px) and compact footer (33px, see\n     secims_view/css/footer.css). */\n  height: calc(100vh - 60px - 33px);\n  position: relative;\n}\n\n.ol-zoom {\n  left: auto;\n  right: 8px;\n}\n\n#zoom-level {\n  position: absolute;\n  top: 70px;\n  right: 8px;\n  z-index: 1;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: bold;\n  color: #333;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n}\n\n.ol-scale-line {\n  left: auto;\n  right: 8px;\n  bottom: 30px;\n}\n\n/* Cartographic key. Anchored 24px above the scale bar (which sits at\n   bottom: 30px), so the two stack cleanly. Width auto-fits content\n   but capped so very long rule labels wrap rather than push the panel\n   off-screen. */\n#map-key {\n  position: absolute;\n  left: 8px;\n  bottom: 54px;\n  z-index: 1;\n  max-width: 240px;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid #c8d2dc;\n  border-radius: 4px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  padding: 6px 9px;\n  font-size: 11px;\n  color: #333;\n  line-height: 1.35;\n}\n\n.map-key-section + .map-key-section {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.map-key-title {\n  font-weight: 600;\n  color: #003f7a;\n  margin-bottom: 3px;\n  /* Wrap rather than ellipsize — the panel has a fixed max-width\n     (#map-key max-width: 240px) so even verbose titles stay bounded,\n     and attribute names (e.g. POPULATION_2000) shouldn't be hidden. */\n  word-break: break-word;\n}\n\n/* Classification attribute inside the title — slightly de-emphasised\n   (regular weight + lower opacity) so the eye lands on the layer name. */\n.map-key-attr {\n  font-weight: 400;\n  font-style: italic;\n  color: #4a6a85;\n}\n\n.map-key-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 1px 0;\n}\n\n.map-key-swatch {\n  display: inline-block;\n  flex-shrink: 0;\n  border-style: solid;\n}\n\n.map-key-swatch-polygon {\n  width: 16px;\n  height: 12px;\n  border-width: 1px;\n}\n\n.map-key-swatch-point {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border-width: 1px;\n}\n\n.map-key-swatch-line {\n  width: 20px;\n  /* height set inline from the rule's stroke width */\n  border: none;\n}\n\n.map-key-label {\n  flex: 1;\n  word-break: break-word;\n}\n\n#compass {\n  position: absolute;\n  bottom: 108px;\n  right: 8px;\n  z-index: 1;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: rgba(0, 63, 122, 0.88);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);\n  cursor: pointer;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#compass:hover {\n  background: rgba(0, 87, 168, 0.95);\n}\n\n#compass-needle {\n  width: 100%;\n  height: 100%;\n  transition: transform 0.1s ease-out;\n}\n\n/* ── Legend Panel ──────────────────────────────────────────────────── */\n\n#legend-panel {\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  z-index: 1000;\n  min-width: 220px;\n  max-width: 280px;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  box-shadow: var(--shadow);\n  color: var(--text);\n  font-size: 12px;\n  overflow: hidden;\n}\n\n/* Toggle button */\n\n#legend-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  cursor: pointer;\n  background: var(--blue);\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n#legend-toggle:hover {\n  background: var(--blue-dark);\n}\n\n#legend-toggle svg {\n  width: 10px;\n  height: 10px;\n  flex-shrink: 0;\n  transition: transform 0.25s ease;\n  transform: rotate(90deg);\n}\n\n#legend-panel.collapsed #legend-toggle svg {\n  transform: rotate(0deg);\n}\n\n/* Collapsible body */\n\n#legend-body {\n  max-height: calc(100vh - 160px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  transition: max-height 0.3s ease, opacity 0.3s ease;\n  opacity: 1;\n}\n\n#legend-panel.collapsed #legend-body {\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n}\n\n/* Sections */\n\n.legend-section {\n  padding: 0 0 4px 0;\n}\n\n.legend-section-title {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: #666;\n  padding: 6px 10px 2px;\n  user-select: none;\n}\n\n.legend-empty {\n  font-size: 11px;\n  font-style: italic;\n  color: #666;\n  padding: 4px 10px 8px;\n}\n\n.legend-divider {\n  border-top: 1px solid var(--grey-200);\n  margin: 4px 0;\n}\n\n/* Layer item row */\n\n.legend-item {\n  transition: opacity 0.2s;\n}\n\n.legend-item.dragging {\n  opacity: 0.4;\n}\n\n.legend-item.drag-over {\n  border-top: 2px solid #0057a8;\n}\n\n.legend-item-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 8px;\n  cursor: default;\n}\n\n.legend-item-row:hover {\n  background: var(--blue-light);\n}\n\n/* Drag handle */\n\n.drag-handle {\n  cursor: grab;\n  color: #666;\n  font-size: 12px;\n  user-select: none;\n  line-height: 1;\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n/* Checkbox */\n\n.legend-checkbox {\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: #0057a8;\n}\n\n/* Thumbnail slot */\n\n.legend-thumbnail {\n  width: 24px;\n  height: 24px;\n  border-radius: 2px;\n  background: #fff;\n  border: 1px solid var(--border);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Layer label */\n\n.legend-label {\n  flex: 1;\n  font-size: 12px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  user-select: none;\n}\n\n/* Accordion chevron */\n\n.legend-chevron {\n  cursor: pointer;\n  font-size: 10px;\n  color: #666;\n  transition: transform 0.2s ease;\n  user-select: none;\n  padding: 0 2px;\n}\n\n.legend-item.open .legend-chevron {\n  transform: rotate(180deg);\n}\n\n/* Accordion panel */\n\n.legend-accordion {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.25s ease, padding 0.25s ease;\n  background: var(--grey-100);\n  padding: 0 10px;\n}\n\n.legend-item.open .legend-accordion {\n  max-height: 120px;\n  padding: 6px 10px;\n}\n\n/* Opacity slider row */\n\n.transparency-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  margin-bottom: 6px;\n}\n\n.transparency-row label {\n  color: #555;\n  white-space: nowrap;\n}\n\n.legend-opacity-slider {\n  flex: 1;\n  height: 4px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: var(--grey-200);\n  border-radius: 2px;\n  outline: none;\n}\n\n/* Track */\n.legend-opacity-slider::-webkit-slider-runnable-track {\n  height: 4px;\n  background: var(--grey-200);\n  border-radius: 2px;\n}\n\n.legend-opacity-slider::-moz-range-track {\n  height: 4px;\n  background: var(--grey-200);\n  border-radius: 2px;\n  border: none;\n}\n\n/* Thumb — draggable circle */\n.legend-opacity-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #0057a8;\n  border: 2px solid #fff;\n  cursor: grab;\n  margin-top: -5px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.legend-opacity-slider::-moz-range-thumb {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #0057a8;\n  border: 2px solid #fff;\n  cursor: grab;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.legend-opacity-slider::-webkit-slider-thumb:active {\n  cursor: grabbing;\n  background: #003f7a;\n  transform: scale(1.15);\n}\n\n.legend-opacity-slider::-moz-range-thumb:active {\n  cursor: grabbing;\n  background: #003f7a;\n  transform: scale(1.15);\n}\n\n.legend-opacity-value {\n  min-width: 32px;\n  text-align: right;\n  color: #555;\n  font-size: 11px;\n}\n\n/* Download and metadata links */\n\n.legend-download-link,\n.legend-metadata-link,\n.legend-zoom-link {\n  display: block;\n  font-size: 11px;\n  color: #0057a8;\n  text-decoration: none;\n  margin-bottom: 4px;\n}\n\n.legend-download-link:hover,\n.legend-metadata-link:hover,\n.legend-zoom-link:hover {\n  text-decoration: underline;\n  color: #003f7a;\n}\n\n.legend-download-note {\n  font-size: 10px;\n  color: #777;\n  font-style: italic;\n}\n\n/* Row wrapper that pairs a download link with \"Zoom to Extent\" —\n   download on the left, zoom right-justified. The margin-left: auto\n   on the zoom link also handles the standalone case (no download\n   link present) by pushing it to the row's right edge. */\n.legend-link-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.legend-link-row > .legend-download-link,\n.legend-link-row > .legend-metadata-link,\n.legend-link-row > .legend-zoom-link {\n  margin-bottom: 0;\n}\n\n.legend-link-row > .legend-zoom-link {\n  margin-left: auto;\n}\n\n/* Scrollbar styling for legend body */\n\n#legend-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n#legend-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n#legend-body::-webkit-scrollbar-thumb {\n  background: rgba(0, 87, 168, 0.25);\n  border-radius: 3px;\n}\n\n#legend-body::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 87, 168, 0.4);\n}\n\n/* ── Feature popup ──────────────────────────────────────────────── */\n\n.ol-popup {\n  background: #fff;\n  border-radius: 6px;\n  padding: 12px 14px 12px 14px;\n  min-width: 200px;\n  max-width: 380px;\n  max-height: 430px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n  font-family: var(--font);\n  font-size: 13px;\n}\n\n.ol-popup:after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #fff;\n}\n\n.ol-popup-closer {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  text-decoration: none;\n  font-size: 18px;\n  color: #999;\n  line-height: 1;\n  z-index: 1;\n}\n\n.ol-popup-closer:hover {\n  color: #333;\n}\n\n.ol-popup-closer:after {\n  content: '\\00d7';\n}\n\n.popup-title {\n  font-weight: 600;\n  font-size: 13px;\n  color: #003f7a;\n  margin-bottom: 6px;\n  padding-bottom: 4px;\n  padding-right: 20px;\n  border-bottom: 2px solid #0057a8;\n}\n\n.popup-table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.popup-table td {\n  padding: 3px 6px 3px 0;\n  border-bottom: 1px solid #f0f0f0;\n  vertical-align: top;\n}\n\n.popup-key {\n  font-weight: 600;\n  color: #555;\n  font-size: 12px;\n  max-width: 140px;\n  word-break: break-word;\n}\n\n.popup-val {\n  color: #333;\n  word-break: break-word;\n}\n\n.popup-val img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n#popup-content {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 350px;\n}\n\n#popup-content .popup-table-wrap {\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Popup tabs */\n\n.popup-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid #e0e0e0;\n  margin-bottom: 6px;\n  flex-shrink: 0;\n}\n\n.popup-tab {\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  padding: 5px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  cursor: pointer;\n  white-space: nowrap;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.popup-tab:hover {\n  color: #003f7a;\n}\n\n.popup-tab.active {\n  color: #003f7a;\n  border-bottom-color: #0057a8;\n}\n\n.popup-tab-panel {\n  display: none;\n  flex: 1;\n  overflow: hidden;\n}\n\n.popup-tab-panel.active {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Metadata modal ─────────────────────────────────────────────── */\n\n#metadata-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.metadata-modal-backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.metadata-modal-content {\n  position: relative;\n  background: #fff;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 640px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.metadata-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #003f7a;\n  color: #fff;\n  border-radius: 8px 8px 0 0;\n  flex-shrink: 0;\n}\n\n.metadata-modal-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.metadata-modal-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.metadata-modal-pdf {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: #fff;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 4px 10px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.metadata-modal-pdf:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.metadata-modal-download {\n  background: #fff;\n  border: 1px solid #fff;\n  color: var(--blue-dark);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 4px 12px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.metadata-modal-download:hover:not(:disabled) {\n  background: #e8f0f9;\n}\n\n.metadata-modal-download:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.metadata-modal-close {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n  opacity: 0.7;\n}\n\n.metadata-modal-close:hover {\n  opacity: 1;\n}\n\n.metadata-modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.metadata-modal-loading {\n  text-align: center;\n  color: #666;\n  padding: 40px 0;\n}\n\n.metadata-modal-error {\n  color: #c62828;\n  padding: 20px;\n  text-align: center;\n}\n\n/* Metadata sections */\n\n.metadata-sections {\n  font-family: var(--font);\n  font-size: 14px;\n  color: #333;\n}\n\n.metadata-section {\n  margin-bottom: 16px;\n}\n\n.metadata-section h4 {\n  margin: 0 0 8px 0;\n  padding: 6px 0;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #003f7a;\n  border-bottom: 2px solid #0057a8;\n}\n\n.metadata-section-body {\n  padding-left: 2px;\n}\n\n.metadata-row {\n  display: flex;\n  padding: 4px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.metadata-label {\n  flex: 0 0 140px;\n  font-weight: 600;\n  color: #555;\n  font-size: 13px;\n}\n\n.metadata-value {\n  flex: 1;\n  word-break: break-word;\n}\n\n.metadata-badge {\n  display: inline-block;\n  background: #e8f0f9;\n  color: #003f7a;\n  padding: 2px 8px;\n  border-radius: 3px;\n  font-size: 12px;\n  margin: 2px 2px;\n}\n\n.metadata-contact {\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n  line-height: 1.6;\n}\n\n.metadata-contact:last-child {\n  border-bottom: none;\n}\n\n.metadata-contact-type {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #003f7a;\n  margin-bottom: 3px;\n}\n\n.metadata-bbox-map {\n  width: 100%;\n  height: 220px;\n  margin-top: 8px;\n  border: 1px solid #f0f0f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.metadata-contact a {\n  color: #0057a8;\n  text-decoration: none;\n}\n\n.metadata-contact a:hover {\n  text-decoration: underline;\n}\n\n.metadata-links a {\n  display: inline-block;\n  background: #0057a8;\n  color: #fff;\n  padding: 4px 10px;\n  border-radius: 3px;\n  font-size: 12px;\n  text-decoration: none;\n  margin: 2px;\n}\n\n.metadata-links a:hover {\n  background: #003f7a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
